import type { Occurrence } from '../types';

export const TEMPO_OPTIONS = ['NOVO', 'ANTIGO'] as const;
export const SITUACAO_OPTIONS = ['', 'Conectado', 'Desconectado'] as const;
export const OCCURRENCE_STATUS = ['Pendente', 'Concluído'] as const;

/** Data-base do SLA: cliente ANTIGO conta a partir da 1ª O.S.; demais, pela abertura. */
export function slaBase(o: Occurrence): string | null {
  return o.tempoCliente === 'ANTIGO' && o.primeiraOS ? o.primeiraOS : o.abertura;
}

export interface Sla {
  cls: 'ok' | 'warn' | 'crit' | '';
  label: string;
  emergencia: boolean;
}

/** Calcula o SLA (≤48h ok, ≤72h alerta, >72h crítico). */
export function sla(dateLike: string | null): Sla {
  if (!dateLike) return { cls: '', label: '', emergencia: false };
  const d = new Date(dateLike);
  const h = (Date.now() - d.getTime()) / 3600000;
  const dias = Math.floor(h / 24);
  const horas = Math.floor(h % 24);
  const label = dias > 0 ? `${dias}d ${horas}h` : `${Math.floor(h)}h`;
  if (h <= 48) return { cls: 'ok', label, emergencia: false };
  if (h <= 72) return { cls: 'warn', label, emergencia: false };
  return { cls: 'crit', label, emergencia: true };
}

export function fmtDateTime(iso?: string | null): string {
  if (!iso) return '—';
  const d = new Date(iso);
  return (
    d.toLocaleDateString('pt-BR', { day: '2-digit', month: '2-digit', year: 'numeric' }) +
    ' ' +
    d.toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' })
  );
}

export function fmtDateShort(iso?: string | null): string {
  if (!iso) return '—';
  return new Date(iso).toLocaleDateString('pt-BR');
}

/** Link de rota do Google Maps a partir das coordenadas do link salvo ou do endereço. */
export function rotaUrl(o: Occurrence): string | null {
  let dest: string | null = null;
  if (o.localizacao) {
    const m = o.localizacao.match(/(-?\d{1,3}\.\d+)\s*[, ]\s*(-?\d{1,3}\.\d+)/);
    if (m) dest = `${m[1]},${m[2]}`;
  }
  if (!dest) {
    const addr = [o.endereco, o.bairro, o.cidade].filter(Boolean).join(', ');
    if (addr) dest = addr;
  }
  if (!dest) return o.localizacao || null;
  return 'https://www.google.com/maps/dir/?api=1&destination=' + encodeURIComponent(dest);
}

/** Filtro de busca textual livre. */
export function matchSearch(o: Occurrence, term: string): boolean {
  const t = term.toLowerCase();
  return [o.contrato, o.nomeCliente, o.endereco, o.bairro, o.cidade, o.ocorrencia, o.tecnico, o.serial]
    .filter(Boolean)
    .some((v) => String(v).toLowerCase().includes(t));
}
